import React from 'react';
import { QuestionTypes } from '../../constants/Question';
import { CreateButton, ExportButton } from 'react-admin';
import Toolbar from '@mui/material/Toolbar';
import ImportButton from '../ImportButton';
import {
  List,
  Edit,
  Datagrid,
  TextField,
  EditButton,
  TextInput,
  BooleanInput,
  SimpleForm,
  FileInput,
  ImageField,
  FileField,
  useDataProvider,
  ArrayInput,
  SimpleFormIterator,
  SingleFieldList,
  ChipField,
  ArrayField,
  Create,
  ReferenceArrayInput,
  SelectInput,
  ReferenceInput,
  SelectArrayInput,
  Filter,
  required,
  AutocompleteInput,
} from 'react-admin';

const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ID" source="id" alwaysOn />
    <TextInput label="Асуулт" source="txt" alwaysOn />
    <ReferenceInput label="Хэл" source="lang" reference="languages" alwaysOn>
      <SelectInput optionText="name" optionValue="id" emptyText="Бүгд" />
    </ReferenceInput>
    <ReferenceInput label="Түвшин" source="lvl" reference="languageLevels" fullWidth alwaysOn>
      <SelectInput optionText="level" optionValue="id" emptyText="Бүгд" />
    </ReferenceInput>
    <TextInput label="Quiz ID" source="quizId" alwaysOn />
  </Filter>
);

const LingoQuestionActions = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    currentSort,
    total,
    basePath,
    exporter,
  } = props;
  const dataProvider = useDataProvider();

  const onParseData = data => {
    dataProvider.importCSV('lingo/questions', { data: Object.values(data) });
  };

  return (
    <Toolbar>
      {filters &&
          React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
          })}
      <CreateButton basePath={basePath} />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
      />
      <ImportButton onParseData={onParseData} />
    </Toolbar>
  );
};

export const LingoQuestionList = props => (
  <List {...props}  filters={<TextFilter/>} actions={<LingoQuestionActions props={props} />}>
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <TextField label="Type" source="type" />
      <TextField label="Хэл" source="Languages.0.code" sortable={false} />
      <ArrayField label="Түвшин" source="LanguageLevels" sortable={false}>
        <SingleFieldList linkType={false}>
          <ChipField source="level" />
        </SingleFieldList>
      </ArrayField>
      <TextField label="Асуулт" source="txt" />
      <TextField label="Quiz ID" source="quizId" />
      <ArrayField source="choices">
        <Datagrid>
          <TextField label="Хариулт" source="txt" />
        </Datagrid>
      </ArrayField>
      <EditButton />
    </Datagrid>
  </List>
);
const LingoQuestionTitle = ({ record }) => {
  return <span>Lingo Question {record ? `"${record.id}"` : ''}</span>;
};

export const LingoQuestionEdit = props => (
  <Edit title={<LingoQuestionTitle />} {...props}>
    <SimpleForm>
      <TextInput source="id" readOnly />
      <ReferenceInput label="Тест" source="quizId" reference="lingo/quizzes" perPage={500}>
        <AutocompleteInput source="quizId" optionText="title" />
      </ReferenceInput>
      <SelectInput source="type" choices={QuestionTypes} />
      <TextInput label="Асуулт" source="txt" />
      <ReferenceInput label="Хэл" source="tagging.languageId" reference="languages">
        <SelectInput source="tagging.languageId" optionText="name" validate={[required()]} />
      </ReferenceInput>
      <ReferenceArrayInput label="Хэлний түвшин" source="tagging.languageLevels" reference="languageLevels">
        <SelectArrayInput source="tagging.languageLevels" optionText="level" />
      </ReferenceArrayInput>
      <ImageField source="photo" label="Current photo" />
      <FileInput source="file" accept="image/png">
        <FileField source="photo" />
      </FileInput>
      <ArrayInput source="choices">
        <SimpleFormIterator>
          <TextInput label="Хариулт" source="txt" />
          <BooleanInput
            label="Зөв хариулт эсэх"
            source="correctAnswer"
            default={false}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);

export const LingoQuestionCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <SelectInput source="type" choices={QuestionTypes} />
      <ReferenceInput label="Тест" source="quizId" reference="lingo/quizzes" perPage={500}>
        <AutocompleteInput source="quizId" optionText="title" />
      </ReferenceInput>
      <TextInput label="Асуулт" source="txt" />
      <ReferenceInput label="Хэл" source="tagging.languageId" reference="languages">
        <SelectInput source="tagging.languageId" optionText="name" validate={[required()]} />
      </ReferenceInput>
      <ReferenceArrayInput  label="Хэлний түвшин" source="tagging.languageLevels" reference="languageLevels">
        <SelectArrayInput source="tagging.languageLevels" optionText="level" />
      </ReferenceArrayInput>
      <ArrayInput source="choices">
        <SimpleFormIterator>
          <TextInput label="Хариулт" source="txt" />
          <BooleanInput label="Зөв хариулт эсэх" source="correctAnswer" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);
